import { IFlowProgress, IFlows } from "@wingspanhq/users";
import { useHistory } from "react-router-dom";
import { useUserId } from "../query/hooks/helpers";
import { useActivities } from "../query/users/queries";

export function useResumeSetupFlow(
  flowName: keyof IFlows,
  stepRouteMap: { [key: number]: string }
) {
  const history = useHistory();
  const userId = useUserId();
  const activityQuery = useActivities(userId);

  const flow = activityQuery.data?.flows[flowName] as IFlowProgress;

  const resume = () => {
    // TODO This is super fragile. What if flow steps change? What about default, what about if complete?
    if (!flow) {
      const currentStep = 1;
      history.push(stepRouteMap[currentStep]);
    } else if (flow.complete === false) {
      history.push(stepRouteMap[flow?.currentStep]);
    }
  };
  return { flow, resume };
}

export function useResume1099SetupFlow() {
  return useResumeSetupFlow(
    "nec1099Setup",
    // If we can reuse the routes array from SetupFlow component,
    // we can generate stepRouteMap.
    {
      1: "/member/1099-filing/set-up/confirm-payer-info",
      2: "/member/1099-filing/set-up/select-import-collaborators",
      3: "/member/1099-filing/set-up/select-off-platform-payments",
      4: "/member/1099-filing/set-up/calculation-settings",
      5: "/member/1099-filing/set-up/state-filing-settings"
    }
  );
}

export function useResume1099OnboardingFlow() {
  return useResumeSetupFlow("onboarding1099", {
    1: "/member/1099-filing/onboarding/business",
    2: "/member/1099-filing/onboarding/personal",
    3: "/member/1099-filing/onboarding/consent",
    4: "/member/1099-filing/onboarding/electronic-1099-consent"
  });
}
